export default {
    data() {
        return {
            disable_warring_popup: false,
        };
    },

    watch: {
        disable_warring_popup(bool) {
            if (bool) {
                this.disableWarringPopup();
            } else {
                this.enableWarringPopup();
            }
        },
    },

    mounted() {
        setTimeout(() => {
            $(".warring-wrap").modal("show");
        }, 1000);
    },

    methods: {
        enableWarringPopup() {
            axios.post(route("storefront.warring_popup.store"));
        },

        disableWarringPopup() {
            axios.delete(route("storefront.warring_popup.destroy"));
        },

        handleOptionAbove18() {
            this.disableWarringPopup();
            $(".warring-wrap").modal("hide");
        }
    },
};
